import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { soundManager } from '../core/audio/sounds/soundManager'
import { preloadSounds } from '../core/audio/sounds/preloadSounds'

/**
 * Binds the store's SFX settings to the sound singleton.
 *
 * Preloading on mount also arms Howler's iOS unlock handlers (they bind on the
 * first Howl constructed), so this needs to run before the player's first tap.
 * No unlock listener and no visibilitychange handling here — see musicManager.
 */
export const useGameSounds = () => {
  const enabled = useSelector((state) => state.ui.audio.sounds.enabled)
  const volume = useSelector((state) => state.ui.audio.sounds.volume)

  useEffect(() => {
    preloadSounds()
  }, [])

  useEffect(() => {
    soundManager.setEnabled(enabled)
  }, [enabled])

  useEffect(() => {
    soundManager.setVolume(volume)
  }, [volume])
}
